module.exports = __webpack_public_path__ + "img/pm.0161730d.svg";